import CenterBarNav from "../CenterBarNav";
import ListCellZ from "../../atoms/ListCellZ";
import Inputz from "../../atoms/Inputz";
import TagGroup from "../TagGroup";
import RadioGroup from "../RadioGroup";
import CheckGroup from "../CheckGroup";
import DropDownz from "../../atoms/DropDownz";
import { data } from "../../../data/itemsData";
import Buttonz from "../../atoms/Buttonz";
import CenterTitleZ from "../../atoms/CenterTitleZ";
import { useEffect } from "react";
import Switchz from "../../atoms/Switchz";

function HomeCenterBar({
  formData,
  handleFormChange,
  handleClearFilters,
  selectedMode,
  itemsNumber,
  debouncedSearch,
  setDebouncedSearch,
  favsNumber,
  icon,
  totalItemsNumber,
  allCatalogCount,
  selectedLanguage,
  onLanguageChange,
}) {
  const AllTags = ["ALL", "Favs", ...data[selectedMode].tags];
  console.log(selectedLanguage);
  // Helper function to get the correct counter number
  const getCounterNumber = () => {
    if (formData.tag === "Favs") {
      return itemsNumber;
    }
    return itemsNumber;
  };

  return (
    <>
      <CenterTitleZ
        title={selectedMode}
        icon={icon}
        className={`${selectedMode}-box big-svg-icon`}
      />

      <div className="search-box">
        <Inputz
          iconL="search"
          hovericonR="mail"
          label="Email address"
          type="email"
          placeholder="Search"
          onChange={(e) => {
            setDebouncedSearch(e.value);
          }}
          iconClear={"close"}
          hovericonClear={"close"}
          value={debouncedSearch || ""}
          name="search"
          counter={getCounterNumber()}
          className={`${selectedMode}-box`}
          counterClassname={`${selectedMode}-text`}
        />


        {/* <Buttonz
        iconL={"clear"}
          onClick={handleClearFilters}
          // label="Clear"
          // className={`${selectedMode}-bg`}
        /> */}
    
      </div>

      {data[selectedMode].tags && (
        <TagGroup
          tags={AllTags}
          selectedTag={formData.tag}
          onChange={handleFormChange}
          name="tag"
          selectedMode={selectedMode}
          favsNumber={favsNumber}
          itemsNumber={totalItemsNumber}
          allCatalogCount={allCatalogCount}
        />
      )}

      {data[selectedMode].radios && (
        <RadioGroup
          options={data[selectedMode].radios}
          onChange={handleFormChange}
          name="radio"
          value={formData.radio}
          selectedMode={selectedMode}
        />
      )}

      {data[selectedMode].checks && (
        <RadioGroup
          options={data[selectedMode].checks}
          onChange={handleFormChange}
          name="check"
          value={formData.check}
          selectedMode={selectedMode}
        />
      )}

      <div className="clear-button">
        <Buttonz
          onClick={handleClearFilters}
          label="Clear"
          className={`${selectedMode}-bg`}
        />
      </div>

      <div className="welcome-text">

      {/* <DropDownz
        // iconL="language"
        // focusL="language"
        iconR="drop_down"
        iconRHover="drop_up"
        onSelect={(e) => onLanguageChange(e)}
        value={selectedLanguage}
        name="language"
        className="lang-select"
      >
        <span value="en">English</span>
        <span value="jp">日本語</span>
      </DropDownz> */}
        {/* Welcome to <div className="welcome_service">{selectedMode}</div> */}
        {/* <div className="welcome-subtext">
          {(() => {
            switch (selectedMode.toLowerCase()) {
              case "tools":
                return "Explore essential design tools and creative software solutions";
              case "resos":
                return "Access curated design resources, templates, and assets";
              case "ideaz":
                return "Discover design inspiration and innovative concepts";
              default:
                return "";
            }
          })()}
        </div> */}
      </div>

    </>
  );
}

export default HomeCenterBar;
